import clsx from "classnames";
import { Container } from "react-bootstrap";

export default function Divider({ sectionId, className }) {
  return (
    <div id={sectionId}>
      <Container className="mw-xxl">
        <hr />
      </Container>
    </div>
  );
}
